import '../app/components/Tooltip.css';
import '../app/style.css';
import React from 'react';
import { Route, useLocation } from 'react-router-dom';
import { Spinner, Provider as TacoProvider } from '@economic/taco';
import { AuthRoutes, i18n, Locale } from '@economic/react-app';
import { I18nProvider } from '@lingui/react';
import { fetchLocalisation } from '~/fetchLocalisation';
import { DataProvider } from '~/app/shared/components/DataContext';
import { NotFound } from './pages/NotFound';

const Document = React.lazy(() => import(/* webpackChunkName: "external.document" */ './pages/Document/Document'));
const SmartBank = React.lazy(() => import(/* webpackChunkName: "external.smartbank" */ './pages/SmartBank'));
const PaymentTakeover = React.lazy(() => import(/* webpackChunkName: "external.paymenttakeover" */ './pages/PaymentTakeover'));

export default function External() {
    const [i18nLoaded, setI18nLoaded] = React.useState(false);
    const { search } = useLocation();
    const language = (new URLSearchParams(search).get('language') as Locale['languageCode']) ?? 'da-DK';

    // the user is unauthenticated, so we use defaults
    const tacoLocalisation = fetchLocalisation(language, 'dd.mm.yy');
    const tacoSettings = { uniqueUserIdentifier: 'unauthenticated' };

    React.useEffect(() => {
        i18n.init(language);
        i18n.load(language, process.env.PUBLIC_URL + '/locales').finally(() => setI18nLoaded(true));
    }, [language]);

    if (!i18nLoaded) {
        return <Spinner className="w-full p-8" />;
    }

    return (
        <React.Suspense fallback={<Spinner className="w-full p-8" />}>
            <I18nProvider i18n={i18n.i18n}>
                <TacoProvider localization={tacoLocalisation} settings={tacoSettings}>
                    <DataProvider>
                        <AuthRoutes>
                            <Route path="document/:key" element={<Document />} />
                            <Route path="smartbank/:key" element={<SmartBank />} />
                            <Route path="paymenttakeover/:key" element={<PaymentTakeover />} />
                            <Route path="*" element={<NotFound />} />
                        </AuthRoutes>
                    </DataProvider>
                </TacoProvider>
            </I18nProvider>
        </React.Suspense>
    );
}
